/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import BackButton from "../../../components/BackButton";
import Card from "../../../components/Card";
import Layout from "../../../layout";
import Cup from "../../../assets/icons/cup.svg";
import CustomButton from "../../../components/CustomButton";
import CustomTextArea from "../../../components/CustomTextArea";
import CustomInput from "../../../components/CustomInput";
import { useHistory, useLocation } from "react-router-dom";
import LeaderList from "./LeaderList";
import cogoToast from "cogo-toast";
import { useDispatch, useSelector } from "react-redux";
import { SectionLoader } from "../../../components/PageLoader";
import {
  Box,
  Grid,
  Paper,
  Typography,
  CardHeader,
  CardContent,
} from "@material-ui/core";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

import pictureLogo from "../../../assets/images/feeds.png";
import { uploadFile } from "../../../utils/helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Points from "./Points";
import "./feeds.css";
import {
  createFeedAction,
  getFeedsAction,
  createCommentPostAction,
  deleteFeedsAction,
} from "../../../redux/actions/feedAction";

const League = () => {
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isMounted = useRef(true);

  const myFormRef = useRef(0);
  const uploadInputRef = useRef(0);
  const [loading, setLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showComments, setShowComment] = useState(false);
  const [commentValue, setCommentValue] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);

  const { get_feed_result } = useSelector((store) => store);

  const [stateRecognition, setStateRecognition] = useState({
    content: "",
    img_url: "",
  });

  const [stateComment, setCommentState] = useState({
    feed_id: "",
    content: "",
  });

  // Scroll to top functionality
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    // Set mounted flag
    isMounted.current = true;

    const fetchFeeds = async () => {
      try {
        setLoading(true);
        await getFeedsAction(dispatch, 1);
      } catch (error) {
        console.error("Error fetching feeds:", error);
      } finally {
        if (isMounted.current) {
          setLoading(false);
        }
      }
    };

    fetchFeeds();

    // Cleanup function
    return () => {
      isMounted.current = false;
    };
  }, [dispatch]);

  const handleChangeUpload = ({ target: { files } }) => {
    if (files && files[0]) {
      setIsUploading(true);

      Promise.resolve(
        uploadFile(
          files[0],
          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
        )
      )
        .then(({ data, success }) => {
          if (success) {
            //addDocLink(data);
            setStateRecognition({ ...stateRecognition, img_url: data });
            // addDocLinkObject({ link: data, name: files[0].name });
          } else {
            cogoToast.error("Unsuccessful document upload", {
              hideAfter: 4,
              position: "top-center",
            });
          }
        })
        .finally(() => {
          setIsUploading(false);
        });
    }
  };

  const handleChange = ({ target: { id, value, checked } }) => {
    setStateRecognition((prevState) => ({ ...prevState, [id]: value }));
  };

  const handleChangeComment = ({ target: { id, value, checked } }) => {
    setCommentState((prevState) => ({ ...prevState, [id]: value }));
  };

  const handleRefClick = () => {
    uploadInputRef.current.click();
  };

  const handleSubmitComment = async (e) => {
    e.preventDefault();
    if (!stateComment.content.trim()) {
      cogoToast.error("Please enter a comment", {
        hideAfter: 3,
        position: "top-center",
      });
      return;
    }

    try {
      const response = await createCommentPostAction(dispatch, {
        ...stateComment,
      });

      if (response?.success && isMounted.current) {
        setCommentState({
          feed_id: "",
          content: "",
        });

        cogoToast.success("Comment added successfully!", {
          hideAfter: 3,
          position: "top-center",
        });
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error adding comment:", error);
        cogoToast.error(
          error.message || "Failed to add comment. Please try again.",
          {
            hideAfter: 4,
            position: "top-center",
          }
        );
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stateRecognition.content.trim()) {
      cogoToast.error("Please enter some content for your post", {
        hideAfter: 3,
        position: "top-center",
      });
      return;
    }

    try {
      if (isMounted.current) {
        setLoading(true);
      }

      const response = await createFeedAction(dispatch, {
        ...stateRecognition,
      });

      if (response?.success && isMounted.current) {
        setStateRecognition({
          content: "",
          img_url: "",
        });

        // Refresh feeds after successful post
        await getFeedsAction(dispatch, 1);

        cogoToast.success("Post created successfully!", {
          hideAfter: 3,
          position: "top-center",
        });
      }
    } catch (error) {
      if (isMounted.current) {
        console.error("Error creating feed:", error);
        cogoToast.error(
          error.message || "Failed to create post. Please try again.",
          {
            hideAfter: 4,
            position: "top-center",
          }
        );
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const deleteFeedSubmit = async (_id) => {
    if (window.confirm("Kindly confirm removal of the Feed")) {
      try {
        const response = await deleteFeedsAction(dispatch, {
          item_id: _id,
        });

        if (response?.success && isMounted.current) {
          cogoToast.success("Post deleted successfully!", {
            hideAfter: 3,
            position: "top-center",
          });
        }
      } catch (error) {
        if (isMounted.current) {
          console.error("Error deleting feed:", error);
          cogoToast.error(
            error.message || "Failed to delete post. Please try again.",
            {
              hideAfter: 4,
              position: "top-center",
            }
          );
        }
      }
    }
  };

  const displayData = () => {
    if (pathname.includes("list")) {
      return <LeaderList />;
    } else if (pathname.includes("point")) {
      return <Points />;
    } else {
      return (
        <div className="w-100 d-flex pt-5 flex-column">
          <div className="col-md-10 gedf-main" style={{ marginLeft: "10%" }}>
            <form onSubmit={handleSubmit}>
              <div className="card gedf-card">
                <div className="card-body">
                  <div className="tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active"
                      id="posts"
                      role="tabpanel"
                      aria-labelledby="posts-tab"
                    >
                      <div className="form-group">
                        <label className="sr-only" htmlFor="message">
                          post
                        </label>

                        <CustomTextArea
                          placeholder="Post a content..."
                          onChange={handleChange}
                          value={stateRecognition.content}
                          name="content"
                          id="content"
                        />
                      </div>
                    </div>

                    <div>
                      <input
                        ref={uploadInputRef}
                        type="file"
                        onChange={handleChangeUpload}
                        style={{ display: "none" }}
                      />
                    </div>
                  </div>

                  <div className="btn-toolbar justify-content-between">
                    <div className="btn-group">
                      <button
                        className="btn mgtr btn-default"
                        type="button"
                        onClick={handleRefClick}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <img src={pictureLogo} className="post-div-logo" />
                          </Grid>

                          <Grid item xs={6}>
                            <img
                              src={stateRecognition.img_url}
                              className="post-div-logo-result"
                            />
                          </Grid>
                        </Grid>
                      </button>
                    </div>
                    <button
                      type="submit"
                      className="btn  

             btn-primary blue-button pull-right"
                    >
                      Post
                    </button>

                    {/* <div className="btn-group">
                <button id="btnGroupDrop1" type="button" className="btn btn-link dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">
                    <i className="fa fa-globe"></i>
                </button>
                <div className="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
                    <a className="dropdown-item" href="#"><i className="fa fa-globe"></i> Public</a>
                    <a className="dropdown-item" href="#"><i className="fa fa-users"></i> Friends</a>
                    <a className="dropdown-item" href="#"><i className="fa fa-user"></i> Just me</a>
                </div> 
            </div>
            */}
                  </div>
                </div>
              </div>
            </form>
            {loading && <SectionLoader />}

            {get_feed_result &&
              Array.isArray(get_feed_result.get_feed_result) &&
              get_feed_result.get_feed_result.map((item, index) => {
                return (
                  <div className="card gedf-card" key={index}>
                    <div className="card-header">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="mr-2">
                            <img
                              className="rounded-circle"
                              width="45"
                              src={item.user[0].image_url}
                              alt=""
                            />
                          </div>
                          <div className="ml-2">
                            <div className="h5 m-0">
                              @{item.user[0].last_name}
                              {item.user[0].first_name}
                            </div>
                            <div className="h7 text-muted">
                              {item.user[0].title}
                            </div>
                          </div>
                        </div>
                        <div>
                          <div className="dropdown">
                            <button
                              className="btn btn-link dropdown-togglex"
                              onClick={() => {
                                deleteFeedSubmit(item.id);
                              }}
                              type="button"
                              id="gedf-drop1"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i className="fa fa-trash"></i>
                            </button>
                            <div
                              className="dropdown-menu dropdown-menu-right"
                              aria-labelledby="gedf-drop1"
                            >
                              <div className="h6 dropdown-header">
                                Configuration
                              </div>
                              <a className="dropdown-item" href="#">
                                Save
                              </a>
                              <a className="dropdown-item" href="#">
                                Hide
                              </a>
                              <a className="dropdown-item" href="#">
                                Report
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="text-muted h7 mb-2">
                        {" "}
                        <i className="fa fa-clock-o"></i>
                        {item.created_at}
                      </div>

                      <p className="card-text">{item.content}</p>
                      <img src={item.img_url} style={{ width: "30%" }} />
                    </div>
                    <div className="card-footer">
                      <Accordion style={{ backgroundColor: "#fff" }}>
                        <AccordionItem>
                          <AccordionItemHeading>
                            <AccordionItemButton>Comments</AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <form
                              ref={myFormRef}
                              onSubmit={handleSubmitComment}
                            >
                              <CustomInput
                                name="comment"
                                label=""
                                onChange={({
                                  target: { id, value, checked },
                                }) => {
                                  setCommentState({
                                    ...stateComment,
                                    feed_id: item.id,
                                    content: value,
                                  });
                                }}
                                id="comment"
                                placeholder="Enter Comment..."
                              />

                              <button
                                type="submit"
                                className="btn btn-primary  btn-sm pull-right"
                              >
                                Comment
                              </button>
                            </form>

                            <div style={{ marginTop: "2.5%" }}>
                              {item.comments.map((item2, index) => {
                                return (
                                  <div
                                    className="comment mt-4 text-justify float-left"
                                    key={index}
                                  >
                                    <img
                                      src={
                                        item2.commented_by_user &&
                                        item2.commented_by_user.image_url
                                          ? item2.commented_by_user.image_url
                                          : "https://res.cloudinary.com/workbrook-hash/image/upload/v1587164870/App/user-circle-02_jbpaez.png"
                                      }
                                      alt=""
                                      className="rounded-circle"
                                      width="40"
                                      height="40"
                                    />
                                    {typeof item2.commented_by_user ===
                                    "object" ? (
                                        <>
                                          <h4 className="black font-size-small">
                                          @
                                            {item2.commented_by_user.first_name
                                              ? item2.commented_by_user.first_name.trim()
                                              : "Unknown"}{" "}
                                            {item2.commented_by_user.last_name
                                              ? item2.commented_by_user.last_name.trim()
                                              : ""}
                                          </h4>
                                          {item2.commented_by_user.title && (
                                            <span>
                                            - {item2.commented_by_user.title}
                                            </span>
                                          )}
                                        </>
                                      ) : (
                                        <h4 className="black font-size-small">
                                        Unknown User
                                        </h4>
                                      )}
                                    <p
                                      style={{ color: "#000", width: "450px" }}
                                    >
                                      {item2.content}
                                    </p>
                                  </div>
                                );
                              })}
                            </div>
                          </AccordionItemPanel>
                        </AccordionItem>
                      </Accordion>
                    </div>
                  </div>
                );
              })}

            {/*
 <div className="card gedf-card">
    <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2">
                    <img className="rounded-circle" width="45" src="https://picsum.photos/50/50" alt="" />
                </div>
                <div className="ml-2">
                    <div className="h5 m-0">@LeeCross</div>
                    <div className="h7 text-muted">Miracles Lee Cross</div>
                </div>
            </div>
            <div>
                <div className="dropdown">
                    <button className="btn btn-link dropdown-toggle" type="button" id="gedf-drop1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fa fa-ellipsis-h"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="gedf-drop1">
                        <div className="h6 dropdown-header">Configuration</div>
                        <a className="dropdown-item" href="#">Save</a>
                        <a className="dropdown-item" href="#">Hide</a>
                        <a className="dropdown-item" href="#">Report</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div className="card-body">
        <div className="text-muted h7 mb-2"> <i className="fa fa-clock-o"></i> 10 min ago</div>
        <a className="card-link" href="#">
            <h5 className="card-title"> Lorem ipsum dolor sit amet consectetur adipisicing elit. Velit consectetur
                deserunt illo esse distinctio.</h5>
        </a>

        <p className="card-text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam omnis nihil, aliquam est, voluptates officiis iure soluta
            alias vel odit, placeat reiciendis ut libero! Quas aliquid natus cumque quae repellendus. Lorem
            ipsum dolor sit amet consectetur adipisicing elit. Ipsa, excepturi. Doloremque, reprehenderit!
            Quos in maiores, soluta doloremque molestiae reiciendis libero expedita assumenda fuga quae.
            Consectetur id molestias itaque facere? Hic!
        </p>
        <div>
        
        </div>
    </div>
    <div className="card-footer">
        <a href="#" className="card-link"><i className="fa fa-gittip"></i> Like</a>
         <a href="#" className="card-link"><i className="fa fa-mail-forward"></i> Comment</a>
    </div>
</div>
 

 <div className="card gedf-card">
    <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex justify-content-between align-items-center">
                <div className="mr-2">
                    <img className="rounded-circle" width="45" src="https://picsum.photos/50/50" alt=""/>
                </div>
                <div className="ml-2">
                    <div className="h5 m-0">@LeeCross</div>
                    <div className="h7 text-muted">Miracles Lee Cross</div>
                </div>
            </div>
            <div>
                <div className="dropdown">
                    <button className="btn btn-link dropdown-toggle" type="button" id="gedf-drop1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i className="fa fa-ellipsis-h"></i>
                    </button>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="gedf-drop1">
                        <div className="h6 dropdown-header">Configuration</div>
                        <a className="dropdown-item" href="#">Save</a>
                        <a className="dropdown-item" href="#">Hide</a>
                        <a className="dropdown-item" href="#">Report</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div className="card-body">
        <div className="text-muted h7 mb-2"> <i className="fa fa-clock-o"></i> Hace 40 min</div>
        <a className="card-link" href="#">
            <h5 className="card-title">Totam non adipisci hic! Possimus ducimus amet, dolores illo ipsum quos
                cum.</h5>
        </a>

        <p className="card-text">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsam sunt fugit reprehenderit consectetur exercitationem odio,
            quam nobis? Officiis, similique, harum voluptate, facilis voluptas pariatur dolorum tempora sapiente
            eius maxime quaerat.
            <a href="https://mega.nz/#!1J01nRIb!lMZ4B_DR2UWi9SRQK5TTzU1PmQpDtbZkMZjAIbv97hU" target="_blank">https://mega.nz/#!1J01nRIb!lMZ4B_DR2UWi9SRQK5TTzU1PmQpDtbZkMZjAIbv97hU</a>
        </p>
    </div>
    <div className="card-footer">
        <a href="#" className="card-link"><i className="fa fa-gittip"></i> Like</a>
         <a href="#" className="card-link"><i className="fa fa-mail-forward"></i> Comment</a>
    </div>
</div>
 
*/}
          </div>

          {/* 
          <img className="d-block mx-auto mt-5" src={Cup} alt="cup" />
          <h5 className="text-center my-5">
            How you earn points in the WB League
          </h5>
          <ul className="d-flex co-gray w-100 flex-column align-items-center justify-content-center">
            <li className="my-1">
              Earn points by completing tasks on the app.
            </li>
            <li className="my-1">Complete your profile to 100%.</li>
            <li className="my-1">Make a successful referral.</li>
            <li className="my-1">Invite a friend to use workbrook.</li>
            <li className="my-1">Convert your earned points to real money.</li>  
          </ul>
          <h5 className="co-primary text-center my-5">
            Complete Your Profile (5pts)
          </h5>

          <div className="w-75 my-3 mx-auto">
            <CustomButton
              handleClick={() => history.push("/league/points")}
              backgroundColor="#3A6ED4"
              color="#fff"
              text="Take me to WB Points"
              additionalClass="my-3"
            />
          </div>  
        */}
        </div>
      );
    }
  };

  return (
    <Layout>
      <BackButton />

      <div className="mx-4x pb-4z">{displayData()}</div>

      {/* Scroll to Top Button */}
      {showScrollButton && (
        <button
          onClick={handleScrollToTop}
          style={{
            position: "fixed",
            bottom: "30px",
            right: "30px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#3A6ED4",
            color: "white",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
            zIndex: 1000,
            transition: "all 0.3s ease",
          }}
          className="scroll-to-top-button"
          aria-label="Scroll to top"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 15l-6-6-6 6" />
          </svg>
        </button>
      )}
    </Layout>
  );
};

export default League;
